/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 10:40:10
 * Copyright 2022 Leedarson, All Rights Reserved.
 */

import { http } from '@shared';

export interface IAddBill {
  countryCode: string;
  postal: string;
  address?: string;
  id?: string;
}

// 查询用户账单信息
const getBillAddress = () => {
  return http.request({
    url: '/api/ipc/recordPlanController/getUserBillInfo',
  });
};

// 修改用户账单信息
const updateUserBillInfo = (data: IAddBill) => {
  return http.request({
    url: '/api/ipc/recordPlanController/updateUserBillInfo',
    method: 'POST',
    data,
  });
};

//  用户创建账单信息
const addUserBillInfo = (data: IAddBill) => {
  return http.request({
    url: '/api/ipc/recordPlanController/addUserBillInfo',
    method: 'POST',
    data,
  });
};

//  通过国家和邮编获取地址
const getAddress = (countryCode: string, postal: string) => {
  return http.request({
    url: `/api/ipc/recordPlanController/address?countryCode=${countryCode}&postal=${postal}`,
  });
};

//  分页查询订单列表信息
const getPageOrderList = (params: {
  pageNum: number;
  pageSize: number;
  orderStatus: string | number;
}) => {
  return http.request({
    url: '/api/ipc/recordPlanController/getPageOrderList',
    params,
  });
};

//  根据订单id，查询订单详情
const getOrderDetail = (orderId: string) => {
  return http.request({
    url: '/api/ipc/recordPlanController/getOrderDetail',
    params: { orderId },
  });
};

export {
  getBillAddress,
  updateUserBillInfo,
  getAddress,
  addUserBillInfo,
  getPageOrderList,
  getOrderDetail,
};
